/**
 * The routes of the authentication module (`authentication-routing.module.ts`), for code that must behave
 * differently while one is showing — the release splash never probes on one, and the header never records
 * one as the last page visited. Keep in step with that routing module.
 */
export const AUTH_ROUTES: ReadonlyArray<string> = [
  '/login', '/two-factor', '/forgot-password', '/reset-password', '/okta-login', '/password-expired'
];

/**
 * Whether a router URL is an authentication route. The query string and hash are ignored, a trailing segment
 * (`/reset-password/:token`) still counts, and the empty path and `/` count too because the root redirects to
 * `/login`.
 */
export function isAuthRoute(url: string): boolean {
  const path = (url ?? '').split(/[?#]/)[0];
  return path === '' || path === '/' || AUTH_ROUTES.some(route => path === route || path.startsWith(`${route}/`));
}
